<template lang="pug">
  div.wallList
    van-grid(:column-num="1", :center="false")
      van-grid-item(v-for="item in dataList", @click="showWallContent(item)")
        div.wallItem
          img(alt="", v-lazy="require('../assets/wall_icon/'+item.wallIcon)")
</template>

<script>
export default {
  name: 'WallList',
  data() {
    return {
      dataList:[],
      wallItemList:[],
    }
  },
  created() {
    
  },
  methods:{
    initList() {
      for (let index = 0; index < this.wallItemList.length; index++) {
        this.dataList.push(this.wallItemList[index])
      }
    },
    showWallContent(item) {
      this.$router.push({
          path: "/wall/content/"+item.wallId
      })
    }
  },
  components:{

  },
  mounted() {
    let wikiData = require("../assets/lang/zh_CN.json")
    this.$nextTick(() => {
      this.wallItemList = wikiData.wallItemList
      this.initList()
    })
  }
}
</script>

<style lang="scss">
.wallList {
  .van-grid-item__content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    width: 90%;
    height: 160%;
    background: url("../assets/wall_list_icon_bg.png") no-repeat;
    background-size: 100% 100%;
  }
  .van-hairline--top::after {
    border-top-width: 0px;
  }
  .van-grid-item__content::after{
    border-width: 0px;
  }
  .van-grid-item {
    padding: 0 0 15% 0;
    justify-content: center;
    display: flex;
  }
  .wallItem {
    width: 90%;
    //height: 91px;
  }
  .wallItem img {
    width: 100%;
    height: 100%;
  }
}
</style>